import { useLazyFileLoad } from "@/shared/hooks";
import { ReplyPreviewProps } from "./reply-preview.props";
import { getFileCategory } from "@/shared/lib";
import { Play } from "react-bootstrap-icons";

export const ReplyPreview = ({
  msg,
  messageItemRef,
  isUserMsg,
  name,
  isSelected = false,
  onClickMessegeReply,
}: ReplyPreviewProps) => {
  const fileUrls = msg.fileUrls ?? [];
  const firstFileUrl = msg.fileUrls?.[0] ?? null;
  const {
    url: previewUrl,
    loading,
    error,
  } = useLazyFileLoad(messageItemRef, firstFileUrl);
  const category = fileUrls.length > 0 ? getFileCategory(fileUrls[0]) : null;
  const baseBg = isUserMsg ? "#e9ecef" : "#5a6268";
  const background = isSelected 
    ? `${baseBg}8a`
    : baseBg;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation()
        onClickMessegeReply(msg._id)
      }}
      className="rounded-2 mb-1 ps-1"
      style={{
        cursor: "pointer",
        paddingBottom: 2,
        background,
        color: isUserMsg ? "#495057" : "#e0e0e0",
        fontSize: "12px",
        borderLeft: `3px solid ${isUserMsg ? "#6c757d" : "#dee2e6"}`,
        display: "flex",
        alignItems: "center",
        gap: "6px",
        userSelect: "none",
        width: "100%",
        paddingRight: 8,
      }}
    >
      {category === "image" && previewUrl && (
        <img
          src={previewUrl}
          alt="Фото"
          style={{
            width: 24,
            height: 24,
            marginTop: 2,
            borderRadius: 4,
            objectFit: "cover",
            flexShrink: 0,
          }}
        />
      )}

      {category === "video" && previewUrl && (
        <div
          style={{
            position: "relative",
            height: 24,
            marginTop: 2,
            flexShrink: 0,
          }}
        >
          <video
            src={previewUrl}
            style={{
              width: 24,
              height: 24,

              borderRadius: 4,
              objectFit: "cover",
            }}
            muted
            preload="metadata"
          />
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Play size={16} color="white" />
          </div>
        </div>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          overflow: "hidden",
          flex: 1,
        }}
      >
        <div
          style={{
            fontWeight: 500,
            fontSize: 12,
            lineHeight: "15px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
          }}
        >
          {name}
        </div>

        {(msg.text?.trim() || fileUrls.length > 0) && (
          <div
            style={{
              fontSize: "10px",
              fontWeight: 400,
              lineHeight: "13px",
              marginTop: "2px",
              color: isUserMsg ? "#6c757d" : "#dcdcdc",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {msg.text?.trim()
              ? msg.text.length > 50
                ? msg.text.slice(0, 50) + "…"
                : msg.text
              : category === "audio"
                ? "Аудиосообщение"
                : category === "video"
                  ? "Видео"
                  : category === "image"
                    ? "Фото"
                    : "Файл"}
          </div>
        )}
      </div>
    </div>
  );
};
